import {
  SelectFilterConfig,
  MultiselectFilterConfig,
  MultiselectSearchFilterConfig,
  InputFilterConfig,
  type FilterConfig,
} from 'src/models/recipe/list/filter-types';

import { fetchCategoryListAsOptionsMap } from 'src/services/category/list-api.ts';
import { fetchPimcoreOptionsMap } from 'src/services/recipe/list-api';

export const FILTERS_CONFIG: FilterConfig[] = [
  new SelectFilterConfig(
    'timeConsuming',
    'Czas przygotowania',
    'timeConsumingCode',
    fetchPimcoreOptionsMap.bind(null, '/api/selectOption/list/OBJECT/recipe/TimeConsuming')
  ),
  new SelectFilterConfig(
    'forHowManyPerson',
    'Dla ilu osób',
    'forHowManyPersonCode',
    fetchPimcoreOptionsMap.bind(null, '/api/selectOption/list/OBJECT/recipe/ForHowManyPerson')
  ),
  new MultiselectFilterConfig(
    'mealTypes',
    'Posiłki',
    'mealTypes',
    fetchPimcoreOptionsMap.bind(null, '/api/recipeCategory/list')
  ),
  new MultiselectSearchFilterConfig(
    'categories',
    'Kategorie',
    'categories',
    fetchCategoryListAsOptionsMap
  ),
  new MultiselectSearchFilterConfig(
    'ingredients',
    'Składniki',
    'ingredients',
    fetchPimcoreOptionsMap.bind(null, '/api/ingredient/list')
  ),
  new InputFilterConfig(
    'search',
    'Wyszukaj',
    'search',
    null
  ),
];

